import { snackbarService } from '/common/snackbarService';

import { IHandlerParams, IOnEventCallback, ISnackbarType } from './types';

export const handleLifecycleEvent = ({ type, queryOrMutation, data, error, variables }: IHandlerParams) => {
  const { meta } = queryOrMutation ?? {};

  if (!meta) {
    return;
  }

  let metaMessageFn;
  let snackbarType: ISnackbarType;

  switch (type) {
    case 'onMutate':
      metaMessageFn = meta.onMutateMessage;
      snackbarType = 'info';
      break;
    case 'onSettled':
      metaMessageFn = meta.onSettledMessage;
      snackbarType = 'info';
      break;
    case 'onSuccess':
      metaMessageFn = meta.onSuccessMessage;
      snackbarType = 'success';
      break;
  }

  if (metaMessageFn === undefined) {
    return;
  }

  let messageToShow: string | undefined;

  if (typeof metaMessageFn === 'function') {
    const payload = type === 'onMutate' ? variables : data;

    const result = (metaMessageFn as IOnEventCallback)(payload, error);

    if (typeof result === 'string') {
      messageToShow = result;
    } else if (typeof result === 'object' && result !== null) {
      messageToShow = result.message;
      if (result.type) {
        snackbarType = result.type;
      }
    }
  } else if (typeof metaMessageFn === 'string') {
    messageToShow = metaMessageFn;
  }

  if (messageToShow) {
    snackbarService[snackbarType](messageToShow);
  }
};
